import { render, staticRenderFns } from "./ActionCard.vue?vue&type=template&id=936df2ce&"
import script from "./ActionCard.vue?vue&type=script&lang=ts&"
export * from "./ActionCard.vue?vue&type=script&lang=ts&"
import style0 from "./ActionCard.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports